import { Modal, Button, Typography, Select, Space, Tag, Row, Input, Col, Divider, Table, Image, Tooltip, Alert } from "antd";
import { CloseOutlined, LockFilled } from "@ant-design/icons";
import { useState } from "react";
import { showMessage } from "../Utils/message";
import { extractOriginalFileName, getUploadUrl, handleDeleteCurrentFile, handleDeleteFile, handleSubmitImage, uploadFileToS3 } from "./CommonFun";
import { Button as UploadButton, IconButton } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AuthService from "../auth/AuthService";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
const { Text } = Typography;
const { TextArea } = Input;
const Auth = new AuthService();

const LockPalletPackingButton = ({ selectedRouteDetails, palletData, setRouteStatusData, drawerClose, routeStatusData }) => {
    const layoutDispatch = useLoadingDispatch()
    const [modalVisible, setModalVisible] = useState(false);
    const [notes, setNotes] = useState("");

    const [files, setFiles] = useState([]);
    const [currentItemFiles, setCurrentItemFiles] = useState([]);
    const [deletedFiles, setDeletedFiles] = useState([]);

    const submitImage = (e) => {
        handleSubmitImage(e, setFiles, setCurrentItemFiles)
    }

      const hasMismatch = palletData.some(item => {
                    const remainingPicked = Number(item?.remaining_quantity ?? 0);
                    return remainingPicked > 0;
                    });


    const handleOk = async () => {
        // if(hasMismatch) return showMessage('error', 'please pack all ')
        if (currentItemFiles?.length < 1) return showMessage('error', 'Add at least one image')

        const dataToSend = {
            route_status_id: selectedRouteDetails?.id,
            notes: notes,
            files: currentItemFiles,
            pallet_builder_id: palletData[0]?.pallet_builder_id,

        }

        showLoading(layoutDispatch);
        const url = '/route/lock-packing-pallet';

        try {
            const res = await Auth.fetch(url, {
                method: 'POST',
                body: JSON.stringify(dataToSend),
            });
            if (res?.ack) {
                setRouteStatusData(prevItems =>
                    prevItems.map(item => {
                        if (item.pallet_id === selectedRouteDetails?.palet_id) {
                            return { ...item, pallet_packed_by: res?.pallet_packed_by || 1 };
                        }
                        return item;
                    })
                );
                const uploadPromises = []
                if (files.length > 0) {
                    console.log('files upload ', files);

                    files.forEach((f) => {
                        uploadPromises.push(
                            getUploadUrl(f, 'route-packing', selectedRouteDetails?.id)
                                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                                .catch(error => console.error("Error uploading file:", error))
                        );
                    });
                }
                await Promise.all(uploadPromises);
                setModalVisible(false);
                drawerClose()
                setNotes('');
                setCurrentItemFiles([])
                setFiles([])



            } else {
                showMessage('error', res?.message);
                hideLoading(layoutDispatch)

            }
        } catch (err) {
            showMessage('error', 'Something went wrong');
            hideLoading(layoutDispatch)

        }
        finally {
            hideLoading(layoutDispatch)
        }
    };

    const handleCancel = () => {
        setModalVisible(false);
        setNotes('');
        setCurrentItemFiles([])
        setFiles([])
    };

  
    return (
        <>
            <Button
                danger
                icon={<LockFilled />}
                onClick={() => {
                
                    setModalVisible(true)

                }}
            >
                Lock Packing
            </Button>

            <Modal
                title="Are you sure to lock packing for this pallet?"
                // centered
                width={'85vw'}
                open={modalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Lock"
                cancelText="Cancel"
                okButtonProps={{ size: "large" }}
                style={{ top: 40 }}
                cancelButtonProps={{ size: "large" }}
                afterClose={() => {
                    setNotes("");
                    setFiles([]);
                    setCurrentItemFiles([]);
                    setDeletedFiles([]);
                }}
                footer={[
                    <Button key="cancel" size="large" onClick={() => setModalVisible(false)}>
                        Cancel
                    </Button>,
                    <Button
                        key="lock"
                        type="primary"
                        danger
                        icon={<LockFilled />}
                        size="large"
                        onClick={handleOk}
                    >
                        Lock
                    </Button>
                ]}
            >
                <Divider style={{ margin: '1px 1px' }} />
                <>
                    <Row style={{ marginTop: '5px' }} gutter={[16, 16]}>
                        <Col xs={24}>
                            <span>
                                Notes:
                            </span>
                            <TextArea
                                value={notes}
                                onChange={(e) => { setNotes(e.target.value) }}
                                placeholder='Notes.'
                                autoSize={{ minRows: 1, maxRows: 6 }}

                            />

                        </Col>
                    </Row>
                    <div style={{ marginBottom: 4 }}>
                        <UploadButton
                            component="label"
                            variant="contained"
                            sx={{ marginTop: "10px" }}
                            startIcon={<CloudUploadIcon />}
                        >
                            Add files
                            <input
                                type="file"
                                hidden
                                multiple
                                capture
                                accept="image/*, video/*"
                            onClick={(e) => {
                        // ensures it always triggers even if same file is picked
                        e.target.value = "";
                    }}
                                onChange={(e) => {
                                    const myfiles = e.target.files;

                                    if (myfiles.length > 10) {
                                        showMessage('error', "A maximum of 10 images can be uploaded at a time.");
                                        e.target.value = "";
                                    } else {
                                        submitImage(e);
                                    }
                                }}
                            />
                        </UploadButton>
                    </div>
                    <Image.PreviewGroup>
                        {files?.length > 0 &&
                            files
                                .filter(
                                    (item) =>
                                        !files.some((file) => file.name === item)
                                )
                                .map((item) => {
                                    return (
                                        <div
                                            style={{
                                                position: "relative",
                                                marginRight: "10px",
                                                display: "inline-block",
                                            }}
                                        >
                                            <Image
                                                width={150}
                                                height={100}
                                                style={{ padding: "5px", border: "1px solid lightgrey" }}
                                                //   src={imageUrl}
                                                src={URL.createObjectURL(item.file)}

                                            />
                                            <Tooltip title="Delete">
                                                <CloseOutlined
                                                    style={{
                                                        fontSize: "30px",
                                                        position: "absolute",
                                                        right: 5,
                                                        top: 5,
                                                        color: "#c12828",
                                                    }}
                                                    onClick={() => handleDeleteFile(item.name, files, currentItemFiles, setFiles, setCurrentItemFiles)}

                                                />
                                            </Tooltip>
                                        </div>
                                    );
                                })}
                    </Image.PreviewGroup>
                 <Row>
                    {
                        hasMismatch && <Alert message="Total quantity is still not packed. Are you sure to lock this pallet packing" type="error" showIcon style={{ marginTop: 10 }} />
                    }
                 </Row>
                </>
            </Modal>
        </>
    );
};

export default LockPalletPackingButton;
